import { ContractDocumentContentRequestInterface } from '../../../../interfaces/request/contracts/contract-document-content-request/contract-document-content-request-interface';

export class ContractDocumentContentRequestModel implements ContractDocumentContentRequestInterface {
  digitalArchiveId: string = '';
  featureName: string = '';
  policyId: number | string | undefined = '';

  constructor(init?: Partial<ContractDocumentContentRequestModel>) {
    Object.assign(this, init);
  }
}
